import * as React from 'react'
import useLayoutEffect from '@react-hook/passive-layout-effect'

function useEvent(target, type, listener) {
  const storedListener = React.useRef(listener)
  storedListener.current = listener

  function _listener(...args) {
    storedListener.current.apply(this, args)
  }

  useLayoutEffect(() => {
    const targetEl = target && 'current' in target ? target.current : target
    if (!targetEl) return
    const listener = _listener
    targetEl.addEventListener(type, listener)
    return () => {
      targetEl.removeEventListener(type, listener)
    }
  }, [target, type])
}

export default useEvent
